








































































import { Prop, Component, Vue } from 'vue-property-decorator'
import { Company } from '@/api/model/company'
import { availableLicenseTypes, availableModules } from '@/api/types'
import moment from 'moment'
import { LicenseAPI } from '@/api/backend-client'

@Component
export default class EditCompanyLicenseForm extends Vue {
    @Prop({ required: true }) readonly company!: Company
    loading: boolean = false
    submitting: boolean = false

    async save(company: Company) {
        try {
            this.loading = true
            this.submitting = true
            await LicenseAPI.update(this.company)
        } finally {
            this.loading = false
            this.submitting = false
            this.$emit('save', this.company)
            this.$emit('close', this.company)
        }
    }

    formatDate(date: Date) {
        return moment(date).format('DD MMMM YYYY')
    }

    get licenseTypeOptions() {
        return availableLicenseTypes().map(value => {
            return {
                label: this.$t(`license.list.licenseType.${ value }`).toString(),
                value,
            }
        })
    }

    get moduleOptions() {
        return availableModules().map(value => {
            return {
                label: this.$t(`license.list.modules.${ value }`).toString(),
                value,
            }
        })
    }

    getModuleValue(module: string): boolean {
        return this.company.modules.includes(module)
    }

    setModuleValue(module: string, value: boolean): void {
        const index = this.company.modules.indexOf(module)

        if (value === true && index === -1) {
            this.company.modules.push(module)
        }

        if (value === false && index !== -1) {
            this.company.modules.splice(this.company.modules.indexOf(module), 1)
        }
    }
}
